export const enum ITokenKeyEnum {
  ACCESS_TOKEN = 'accessToken',
  REFRESH_TOKEN = 'refreshToken',
  TOKEN_TYPE = 'tokenType',
  EXPIRES_IN = 'expiresIn',
  SCOPE = 'scope',
  DEFAULT_TOKEN_TYPE = 'Bearer',
}
